/* eslint-disable consistent-return */
import { find, isNil, map } from 'lodash';

import { LAYER_SUBTYPES } from '../api/Layers/Layers';

import { loadXMLFromURL } from './load-xml-from-url';

/**
 * Fetch the names of the styles of one layer for a WMS layer stored in the URL.
 *
 * @async
 * @param {string} url - The URL where the WMS is stored.
 * @param {string} layerTarget - The name of the layer WMS stored.
 * @param {string} [connectionParams={}] - The user-password pair for the connection.
 * @returns {Array} The WMS layer styles names.
 * @throws {Error} If something goes wrong.
 */
const getWMSStyleNamesFromURL = async (url, layerTarget, connectionParams = {}) => {
  try {
    const xmlText = await loadXMLFromURL(url, LAYER_SUBTYPES.WMS, connectionParams);
    const parser = new DOMParser();
    const xmlDoc = parser.parseFromString(xmlText, 'text/xml');
    const layers = xmlDoc.getElementsByTagName('Layer');

    const definedLayer = find(
      layers,
      layer =>
        layer.getElementsByTagName('Name')[0].innerHTML.trim() === layerTarget &&
        layer.hasAttribute('queryable')
    );

    let layerStyles = [];
    if (!isNil(definedLayer)) {
      const insideStyles = definedLayer.getElementsByTagName('Style');
      layerStyles = map(insideStyles, insideStyle =>
        insideStyle.getElementsByTagName('Name')[0].textContent.trim()
      );
    }

    return layerStyles;
  } catch (error) {
    throw new Error(error.message);
  }
};

export default getWMSStyleNamesFromURL;
